<template>
  <v-form ref="form">
    <v-row>
      <v-col class="py-0" cols="12">
        <v-autocomplete
          v-model="contact._addressbook.id"
          :items="addressbooks"
          item-text="name"
          item-value="id"
          :label="$t('contacts.addressbook')"
          :loading="resourceLoading"
          :rules="
            resourceLoading
              ? []
              : [rules.required, backEndValidation('addressbook_id')]
          "
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-divider class="my-5" />
    <v-row>
      <v-col class="py-0" cols="12">
        <v-text-field
          ref="organization_name"
          v-model="contact.organization_name"
          :label="$t('contacts.organization-name')"
          :loading="resourceLoading"
          :rules="
            resourceLoading
              ? []
              : [
                  ownRules.requiredIfGivenNameAndFamilyNameIsEmpty,
                  backEndValidation('organization_name')
                ]
          "
        ></v-text-field>
      </v-col>
      <v-col class="py-0" cols="12" sm="6">
        <v-text-field
          ref="given_name"
          v-model="contact.given_name"
          :label="$t('contacts.given-name')"
          :loading="resourceLoading"
          :rules="
            resourceLoading
              ? []
              : [
                  ownRules.requiredIfOrganizationIsEmpty,
                  backEndValidation('given_name')
                ]
          "
        ></v-text-field>
      </v-col>

      <v-col class="py-0" cols="12" sm="6">
        <v-text-field
          ref="family_name"
          v-model="contact.family_name"
          :label="$t('contacts.family-name')"
          :loading="resourceLoading"
          :rules="
            resourceLoading
              ? []
              : [
                  ownRules.requiredIfOrganizationIsEmpty,
                  backEndValidation('family_name')
                ]
          "
        ></v-text-field>
      </v-col>
      <v-col class="py-0" cols="12">
        <v-text-field
          v-model="contact.additional_name"
          :label="$t('contacts.additional-name')"
          :loading="resourceLoading"
          :rules="resourceLoading ? [] : [backEndValidation('additional_name')]"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-divider class="my-5" />
    <v-row>
      <v-col class="py-0" cols="12">
        <v-text-field
          ref="address_1"
          v-model="contact.address_1"
          :label="$t('contacts.address-1')"
          :loading="resourceLoading"
          :rules="resourceLoading ? [] : [backEndValidation('address_1')]"
        ></v-text-field>
      </v-col>
      <v-col class="py-0" cols="12">
        <v-text-field
          v-model="contact.address_2"
          :label="$t('contacts.address-2')"
          :loading="resourceLoading"
          :rules="resourceLoading ? [] : [backEndValidation('address_2')]"
        ></v-text-field>
      </v-col>
      <v-col class="py-0" cols="12" sm="4">
        <v-text-field
          ref="address_postcode"
          v-model="contact.address_postcode"
          :label="$t('contacts.address-postcode')"
          :loading="resourceLoading"
          :rules="
            resourceLoading ? [] : [backEndValidation('address_postcode')]
          "
        ></v-text-field>
      </v-col>
      <v-col class="py-0" cols="12" sm="8">
        <v-text-field
          ref="address_city"
          v-model="contact.address_city"
          :label="$t('contacts.address-city')"
          :loading="resourceLoading"
          :rules="resourceLoading ? [] : [backEndValidation('address_city')]"
        >
          <linkMap slot="append" :item="contact"></linkMap>
        </v-text-field>
      </v-col>
      <v-col class="py-0" cols="12" sm="6">
        <v-text-field
          v-model="contact.address_region"
          :label="$t('contacts.address-region')"
          :loading="resourceLoading"
          :rules="resourceLoading ? [] : [backEndValidation('address_region')]"
        ></v-text-field>
      </v-col>
      <v-col class="py-0" cols="12" sm="6">
        <v-autocomplete
          v-model="contact.address_country_code"
          :items="countries"
          item-value="code"
          item-text="name"
          :label="$t('contacts.address-country')"
          :loading="resourceLoading"
          :rules="
            resourceLoading ? [] : [backEndValidation('address_country_code')]
          "
        ></v-autocomplete>
      </v-col>
      <v-col class="py-0" cols="12">
        <v-autocomplete
          v-model="contact.preferred_document_delivery"
          :items="deliveries"
          item-value="value"
          item-text="type"
          :label="$t('contacts.preferred-document-delivery')"
          :loading="resourceLoading"
          :rules="
            resourceLoading
              ? []
              : [backEndValidation('preferred_document_delivery')]
          "
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-divider class="my-5" />
    <v-row>
      <v-col class="py-0" cols="12">
        <v-text-field
          v-model="contact.iban"
          :label="$t('contacts.iban')"
          :loading="resourceLoading"
          :rules="
            resourceLoading ? [] : [rules.iban, backEndValidation('iban')]
          "
        ></v-text-field>
      </v-col>
    </v-row>
    <v-divider class="my-5" />
    <v-row>
      <v-col class="py-0" cols="12" sm="6">
        <v-text-field
          ref="email"
          v-model="contact.email"
          :label="$t('contacts.email')"
          :loading="resourceLoading"
          :rules="
            resourceLoading ? [] : [rules.email, backEndValidation('email')]
          "
        >
          <linkMail slot="append" :email="contact.email"></linkMail>
        </v-text-field>
      </v-col>
      <v-col class="py-0" cols="12" sm="6">
        <v-text-field
          v-model="contact.telephone"
          :label="$t('contacts.telephone')"
          :loading="resourceLoading"
          :rules="resourceLoading ? [] : [backEndValidation('telephone')]"
        >
          <linkTel slot="append" :tel="contact.telephone"></linkTel>
        </v-text-field>
      </v-col>
    </v-row>
    <v-divider class="my-5" />
    <v-row>
      <v-col class="py-0" cols="12">
        <v-textarea
          v-model="contact.notices"
          :label="$t('contacts.notices')"
          :loading="resourceLoading"
          :rules="resourceLoading ? [] : [backEndValidation('notices')]"
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <ButtonWithMenu
          :loading="loading"
          :menu-hide="button_title !== 'create'"
          :general-button="{
            icon: $props.button_icon,
            text: `buttons.${$props.button_title}`,
            eventFunction: save
          }"
          :menu-items="[
            {
              icon: $props.button_icon,
              text: `buttons.create-and-new`,
              eventFunction: saveAndNew
            },
            {
              icon: $props.button_icon,
              text: `buttons.create-and-clone`,
              eventFunction: saveAndClone
            }
          ]"
        ></ButtonWithMenu>
        <template v-if="button_title !== 'create'">
          <v-btn
            class="ml-4"
            color="primary"
            :to="{
              name: 'NewContact',
              query: {
                contact: contact.id
              }
            }"
            :loading="loading"
          >
            <v-icon left>mdi-plus</v-icon>
            {{ $t(`buttons.clone`) }}
          </v-btn>
        </template>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { rules } from "./../mixins/rules";
import linkMap from "../common/links/linkMap";
import linkTel from "../common/links/linkTel";
import linkMail from "../common/links/linkMail";
import ButtonWithMenu from "../common/buttons/ButtonWithMenu";
export default {
  name: "FormContact",
  components: {
    linkMap,
    linkTel,
    linkMail,
    ButtonWithMenu
  },
  mixins: [rules],
  data: () => ({
    loading: false
  }),
  props: {
    dispatch: String,
    button_title: String,
    button_icon: String,
    contact: {
      default: function() {
        return {
          _addressbook: { id: null },
          organization_name: "",
          given_name: "",
          family_name: "",
          email: "",
          address_1: "",
          address_postcode: "",
          address_city: "",
          preferred_document_delivery: "Unspecified"
        };
      }
    },
    resourceLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    addressbooks: {
      get() {
        return this.$store.getters["addressbookStore/getList"].filter(a =>
          a._permissions.find(p => p === "addressbook.read")
        );
      }
    },
    countries: {
      get() {
        return this.$store.getters["localizationStore/countryStore/getList"];
      }
    },
    deliveries: {
      get() {
        return [
          {
            type: this.$i18n.t("contacts.Unspecified"),
            value: "Unspecified"
          },
          {
            type: this.$i18n.t("contacts.PhysicalMail"),
            value: "PhysicalMail"
          },
          {
            type: this.$i18n.t("contacts.ElectronicMail"),
            value: "ElectronicMail"
          }
        ];
      }
    },
    ownRules() {
      var vm = this;
      return {
        requiredIfOrganizationIsEmpty: value => {
          return (
            !!vm.contact.organization_name ||
            !!value ||
            this.$i18n.t("validate.required-if-organization-name-is-empty")
          );
        },
        requiredIfGivenNameAndFamilyNameIsEmpty: value => {
          return (
            (!!vm.contact.given_name && !!vm.contact.family_name) ||
            !!value ||
            this.$i18n.t(
              "validate.required-if-family-name-and-given-name-is-empty"
            )
          );
        },
        requiredIfPreferredDocumentDeliveryIsPhysicalMail: value => {
          return (
            (!!vm.contact.address_1 &&
              !!vm.contact.address_postcode &&
              !!vm.contact.address_city) ||
            !!value ||
            this.$i18n.t(
              "validate.required-if-preferred-document-delivery-is-physical-mail"
            )
          );
        },
        requiredIfPreferredDocumentDeliveryIsEMail: value => {
          return (
            !!vm.contact.email ||
            !!value ||
            this.$i18n.t(
              "validate.required-if-preferred-document-delivery-is-e-mail"
            )
          );
        }
      };
    }
  },
  methods: {
    save(callback = this.defaultCallbackForSave) {
      this.clearBackEndErrors();
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$store
          .dispatch(this.$props.dispatch, {
            item: { ...this.contact },
            errorHandler: this.errorHandler.bind(this, () => {
              this.$refs.form.validate();
            }),
            onSuccess: item => {
              if (item !== "") {
                callback(item);
              }
            }
          })
          .finally(() => (this.loading = false));
      }
    },
    saveAndClone() {
      let callback = i => {
        let { id, ...item } = i;
        this.$store.commit("contactStore/set", { item });
        this.$router.push({
          name: "NewContact",
          query: {
            contact: id
          }
        });
        this.$store.dispatch(
          "notificationStore/createSuccessNotificationForApiRequest",
          {
            text: this.$t(`message.success-create`)
          }
        );
      };
      this.save(callback);
    },
    saveAndNew() {
      let callback = () => {
        this.$route.query.contact && this.$router.push({ name: "NewContact" });
        for (let member in this.contact) {
          let value = null;
          if (member === "_addressbook") {
            value = { id: null };
          }
          this.$set(this.contact, member, value);
          this.$refs.form.resetValidation();
        }
      };
      this.save(callback);
    },
    defaultCallbackForSave(item) {
      this.$store.commit("contactStore/set", { item });
      this.$router.push({
        name: "Contact",
        params: {
          id: item.id
        }
      });
    }
  },
  watch: {
    "contact.organization_name"() {
      if (this.ownRules.requiredIfOrganizationIsEmpty()) {
        this.$refs.given_name.validate();
        this.$refs.family_name.validate();
      }
    },
    "contact.given_name"() {
      if (this.ownRules.requiredIfGivenNameAndFamilyNameIsEmpty()) {
        this.$refs.organization_name.validate();
      }
    },
    "contact.family_name"() {
      if (this.ownRules.requiredIfGivenNameAndFamilyNameIsEmpty()) {
        this.$refs.organization_name.validate();
      }
    },
    "contact.email"() {
      if (this.ownRules.requiredIfPreferredDocumentDeliveryIsEMail()) {
        this.$refs.email.validate();
      }
    },
    "contact.address_1"() {
      if (this.ownRules.requiredIfPreferredDocumentDeliveryIsPhysicalMail()) {
        this.$refs.address_1.validate();
      }
    },
    "contact.address_postcode"() {
      if (this.ownRules.requiredIfPreferredDocumentDeliveryIsPhysicalMail()) {
        this.$refs.address_postcode.validate();
      }
    },
    "contact.address_city"() {
      if (this.ownRules.requiredIfPreferredDocumentDeliveryIsPhysicalMail()) {
        this.$refs.address_city.validate();
      }
    }
  },
  created() {
    this.contact._addressbook.id =
      this.contact._addressbook.id || this.$route.query.addressbook;
    this.$store.dispatch("addressbookStore/getList", {
      params: { limit: -1 }
    });
    this.$store.dispatch("localizationStore/countryStore/getList", {
      params: { limit: -1 }
    });
  }
};
</script>

<style scoped></style>
